import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-15790fc0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "sale-data"
};
var _hoisted_2 = {
  class: "search-box"
};
var _hoisted_3 = {
  class: "header"
};
var _hoisted_4 = {
  class: "flex align-center justify-between"
};
var _hoisted_5 = {
  class: "total-text"
};
var _hoisted_6 = {
  class: "total-text"
};
var _hoisted_7 = {
  class: "mr-2"
};
var _hoisted_8 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "合计吨数:", -1);
});
var _hoisted_9 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "吨", -1);
});
var _hoisted_10 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "合计金额:", -1);
});
var _hoisted_11 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("span", null, "元", -1);
});
var _hoisted_12 = {
  class: "container"
};
var _hoisted_13 = {
  key: 1,
  class: "box"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_search = _resolveComponent("van-search");
  var _component_c_type_tab = _resolveComponent("c-type-tab");
  var _component_date_header_with_btn = _resolveComponent("date-header-with-btn");
  var _component_van_sticky = _resolveComponent("van-sticky");
  var _component_ListDataItem = _resolveComponent("ListDataItem");
  var _component_van_list = _resolveComponent("van-list");
  var _component_c_no_data = _resolveComponent("c-no-data");
  var _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_sticky, null, {
    default: _withCtx(function () {
      return [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_search, {
        modelValue: _ctx.params.condition,
        "onUpdate:modelValue": [_cache[0] || (_cache[0] = function ($event) {
          return _ctx.params.condition = $event;
        }), _ctx.onSearch],
        placeholder: "搜索全部记录",
        shape: "round",
        background: "#ffffff"
      }, null, 8, ["modelValue", "onUpdate:modelValue"])]), _createElementVNode("div", _hoisted_3, [_createVNode(_component_c_type_tab, {
        typeTabs: ['日', '周', '月', '自定义'],
        onConfirmType: _ctx.confirmType
      }, null, 8, ["onConfirmType"]), _createVNode(_component_date_header_with_btn, {
        ref: "dateRef",
        type: _ctx.params.type,
        "show-btn": false,
        onConfirmDate: _ctx.confirmDate
      }, null, 8, ["type", "onConfirmDate"]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, "共" + _toDisplayString(_ctx.totalRow) + "条记录", 1), _createElementVNode("div", _hoisted_6, [_createElementVNode("span", _hoisted_7, [_hoisted_8, _createElementVNode("span", null, _toDisplayString(_ctx.totalWeight), 1), _hoisted_9]), _createElementVNode("span", null, [_hoisted_10, _createElementVNode("span", null, _toDisplayString(_ctx.totalPay), 1), _hoisted_11])])])])];
    }),
    _: 1
  }), _createElementVNode("div", _hoisted_12, [_createVNode(_component_van_pull_refresh, {
    modelValue: _ctx.refreshing,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
      return _ctx.refreshing = $event;
    }),
    onRefresh: _ctx.onRefresh
  }, {
    default: _withCtx(function () {
      return [_ctx.summaryData.length ? (_openBlock(), _createBlock(_component_van_list, {
        key: 0,
        loading: _ctx.loading,
        "onUpdate:loading": _cache[1] || (_cache[1] = function ($event) {
          return _ctx.loading = $event;
        }),
        finished: _ctx.finished,
        "finished-text": "没有更多了",
        onLoad: _ctx.onLoad,
        "immediate-check": false
      }, {
        default: _withCtx(function () {
          return [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.summaryData, function (item, index) {
            return _openBlock(), _createBlock(_component_ListDataItem, {
              key: index,
              index: index,
              item: item
            }, null, 8, ["index", "item"]);
          }), 128))];
        }),
        _: 1
      }, 8, ["loading", "finished", "onLoad"])) : _ctx.finished && !_ctx.summaryData.length ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_c_no_data)])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["modelValue", "onRefresh"])])]);
}